<mat-icon class="arc-align-{{ columnModel.columnTitleAlignment }}" [ngStyle]="{ color: color }" [matTooltip]="tooltip | transloco">
    {{ icon }}
</mat-icon>
